import React from 'react'

import { useAnalyticsEvents } from '../../../hooks/useAnalyticsEvents'
import { Banner as BannerUI } from '../../ui/Banner'

import type { GenericBanner } from '../../../types/CMS'

export interface BannerProps {
  data?: GenericBanner
  openNewTab?: boolean
  className?: string
  onClick?: (e: React.MouseEvent) => void
}

export const Banner = ({
  data,
  openNewTab,
  className,
  onClick,
}: BannerProps) => {
  const { visibility, desktop, mobile, alt, promotionName, href } = data ?? {}
  const { selectPromotion } = useAnalyticsEvents()

  const handleClick = (e: React.MouseEvent) => {
    onClick?.(e)

    selectPromotion({
      href,
      promotionName,
      locale: window.location.href,
    })

    if (!href) {
      e.preventDefault()
    }
  }

  if (!visibility) {
    return null
  }

  return (
    <BannerUI
      href={href}
      src={desktop?.src}
      srcMobile={mobile?.src}
      alt={alt}
      bannerWidth={mobile?.width}
      bannerHeight={mobile?.height}
      bannerDeskWidth={desktop?.width}
      bannerDeskHeight={desktop?.height}
      className={className}
      handleClick={handleClick}
      openNewTab={openNewTab}
    />
  )
}
